import { jsx as _jsx } from "react/jsx-runtime";
export function Spinner({ size = 24 }) {
    return (_jsx("div", { className: "border-2 border-white/10 border-t-white/60 rounded-full", style: {
            width: size,
            height: size,
            animation: 'spin 0.7s linear infinite',
        } }));
}
